import { ValidatorFn, Validators } from '@angular/forms';

export function phoneUSValidator(): ValidatorFn {
  return Validators.pattern('^\\+1\\s\\([0-9]{3}\\)\\s[0-9]{3}-[0-9]{4}$');
}

export function phoneValidator(): ValidatorFn {
  return Validators.pattern('^\\([0-9]{3}\\)\\s[0-9]{3}-[0-9]{4}$');
}
